module.exports = __webpack_public_path__ + "img/260720945_3_9.ba22573e.png";